import { render } from "./TeamManageMenuView.vue?vue&type=template&id=76a95b6a"
import script from "./TeamManageMenuView.vue?vue&type=script&lang=js"
export * from "./TeamManageMenuView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__